var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import { useHistory } from 'react-router';
import chroma from 'chroma-js';
import { useAuth } from '../../';
import { Spinner } from '@web/utils';
import { styled } from '@web/theme';
import { AuthWrapper } from './AuthWrapper';
import { FirebaseUI } from '../FirebaseUI';
export var Auth = memo(function (_a) {
    var onClose = _a.onClose;
    var auth = useAuth().auth;
    var history = useHistory();
    var _onClose = function () { return onClose ? onClose() : history.goBack(); };
    return (React.createElement(AuthWrapper, null, auth.user
        ? React.createElement(Spinner, null)
        : React.createElement(React.Fragment, null,
            React.createElement(FirebaseUI, { redirectUrl: undefined }),
            React.createElement(CloseButton, { onClick: _onClose }, "Zp\u011Bt"))));
});
var CloseButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-top: 2em;\n\tpadding: 1em 3em;\n\tbackground: none;\n\tborder: none;\n\toutline: none;\n\tcursor: pointer;\n\ttext-transform: uppercase;\n\t\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"], ["\n\tmargin-top: 2em;\n\tpadding: 1em 3em;\n\tbackground: none;\n\tborder: none;\n\toutline: none;\n\tcursor: pointer;\n\ttext-transform: uppercase;\n\t\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"])), function (_a) {
    var theme = _a.theme;
    return chroma(theme.page.bg).darken(.1).hex();
});
var templateObject_1;
